<div mat-dialog-title>
    <h2>
        {{"workingHours.Configure store working hours" | translate}}</h2>
    <button mat-icon-button [disabled]="loading" (click)="openConfirmDialog()" class="close" aria-label="Close">
        <mat-icon class="pop-close">close</mat-icon>
    </button>
</div>
<form [formGroup]="formGroup">
    <ng-container *ngIf='!dataLoading'>
        <mat-dialog-content>
            <div class="mat-dialog-body" formArrayName="workingHours">
                <div class="working-day" *ngFor="let day of workingHours.controls; let i = index" [formGroupName]="i">
                    <mat-slide-toggle (toggleChange)="openCloseDay(i)"
                        formControlName="is_opened">{{data.working_hours[i].name}}</mat-slide-toggle>
                    <div class="clocks" [hidden]="!day.value.is_opened">
                        <div class="form-to-time d-flex">
                            <mat-form-field>
                                <input matInput [ngxTimepicker]="startTime" readonly formControlName="start_at"
                                    [required]="day.value.is_opened && !day.value.start_at" [format]="12">
                                <div matSuffix class="d-flex align-items-center">
                                    <ngx-material-timepicker-toggle [for]="startTime"></ngx-material-timepicker-toggle>
                                </div>
                                <ngx-material-timepicker #startTime></ngx-material-timepicker>
                                <mat-error *ngIf="day.value.is_opened && hasError('start_at',i, 'required')">{{
                                    'forms.Required' | translate
                                    }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <!-- <ng-container *ngIf="day.value.start_at"> -->
                            <p class="ml-2 mr-2 font-16 fontMedium">{{'packages.To' | translate}}</p>
                            <div class="form-to-time d-flex">
                                <mat-form-field>
                                    <!-- [min]="convertToEnglishTime(day.value.start_at)" -->
                                    <input matInput [ngxTimepicker]="closedTime" readonly formControlName="closed_at"
                                        [required]="day.value.is_opened && !day.value.closed_at" [format]="12">
                                    <div matSuffix class="d-flex align-items-center">
                                        <ngx-material-timepicker-toggle
                                            [for]="closedTime"></ngx-material-timepicker-toggle>
                                    </div>
                                    <ngx-material-timepicker #closedTime></ngx-material-timepicker>
                                    <mat-error *ngIf="day.value.is_opened && hasError('closed_at',i, 'required')">{{
                                        'forms.Required' | translate
                                        }}
                                    </mat-error>
                                    <mat-error *ngIf="day.value.is_opened && hasError('closed_at',i, 'min')">{{
                                        'forms.Invalid value' | translate
                                        }}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        <!-- </ng-container> -->
                    </div>
                </div>
            </div>
        </mat-dialog-content>
    </ng-container>
    <div *ngIf='dataLoading' class="dataLoading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>
    <mat-dialog-actions>
        <button mat-button class="btn-secondary" type="button" [disabled]="loading" (click)="openConfirmDialog()">
            {{"general.Cancel" | translate}}
        </button>
        <button mat-button class="btn-light" [disabled]="loading" [class.loading]="loading"
            (click)="saveWorkingHours()">
            {{"employees.save" | translate}}
        </button>
    </mat-dialog-actions>
</form>